import { Button, Col, Form, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import api from "../../api/api";

const EditEnvelopeModal = ({ show, onHide, envelopeCost, onUpdate }) => {
  const formik = useFormik({
    initialValues: {
      amount: parseFloat(envelopeCost?.amount),
      appliedAutomatically: envelopeCost?.appliedAutomatically ?? true,
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Amount is required").positive("Amount must be positive"),
      appliedAutomatically: Yup.boolean(),
    }),
    onSubmit: async (values) => {
      const payload = {
        ...values,
      };
      try {
        const response = await api.post(
          `api/cost-envelope/${envelopeCost?.for_case ?? 0}/`,
          payload
        );
        if (onUpdate && response.data && response.data.updatedEnvelopeCost) {
          onUpdate(response.data.updatedEnvelopeCost);
        }
      } catch (error) {
        console.error(error);
      } finally {
        onHide();
      }
    },
  });

  return (
    <Modal contentClassName="custom-modal-new-provider" show={show} onHide={onHide} centered>
      <div style={{ width: "500px" }}>
        <Modal.Header
          style={{
            borderBottom: "0px",
          }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            id="modal_title"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Add/Edit Envelope Cost
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Body className="p-0">
            <Form.Group as={Col} style={{ position: "relative" }} className="p-l-5 p-r-5 m-b-5">
              <Form.Label
                className="m-b-5"
                style={{
                  color: "var(--primary-25)",
                  fontWeight: "600",
                }}
              >
                Edit Envelope Amount:
              </Form.Label>
              <div className="d-flex-1 p-0 d-flex align-items-center position-relative">
                <span
                  style={{
                    position: "absolute",
                    left: "6px",
                    lineHeight: "25px",
                    pointerEvents: "none",
                    zIndex: 1,
                  }}
                >
                  $
                </span>
                <Form.Control
                  type="text"
                  placeholder="0.00"
                  className="rounded-0 height-25"
                  style={{ paddingLeft: "18px" }}
                  name="amount"
                  value={formik.values.amount}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/[^0-9.]/g, "");
                    const parts = raw.split(".");
                    const cleaned =
                      parts.length > 2 ? parts[0] + "." + parts.slice(1).join("") : raw;
                    formik.setFieldValue("amount", cleaned);
                  }}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.touched.amount && !!formik.errors.amount}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.amount}</Form.Control.Feedback>
              </div>

              <Form.Control.Feedback type="invalid">{formik.errors.amount}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="m-b-5 p-l-5 p-r-5" controlId="formHorizontalCheck">
              <div
                className="d-flex align-items-center"
                style={{
                  gap: "5px",
                }}
              >
                <input
                  type="checkbox"
                  id="appliedAutomatically"
                  name="appliedAutomatically"
                  checked={formik.values.appliedAutomatically}
                  onChange={formik.handleChange}
                />
                <label htmlFor="appliedAutomatically" className="mb-0">
                  Apply Automatically
                </label>
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer
            className="p-0 mt-0 padding-outside-btn-new-provider"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider p-2 d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={onHide}
            >
              Cancel
            </Button>
            <Button
              className="button-padding-footer-new-provider p-2 d-flex align-items-center justify-content-center "
              variant="success"
              type="submit"
            >
              Edit Envelope Cost
            </Button>
          </Modal.Footer>
        </Form>
      </div>
    </Modal>
  );
};

export default EditEnvelopeModal;
